import { render } from "./modal-add-shipment-destination.vue?vue&type=template&id=6ea5a3fa&ts=true"
import script from "./modal-add-shipment-destination.vue?vue&type=script&lang=ts"
export * from "./modal-add-shipment-destination.vue?vue&type=script&lang=ts"

import "./modal-add-shipment-destination.vue?vue&type=style&index=0&id=6ea5a3fa&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__